import React, { useEffect } from 'react';
import { Menu, X } from 'react-feather';
import '../../components/styles/MobileSidebarControl.css';

const MobileSidebarControl = ({ sidebarOpen, setSidebarOpen }) => {
  // Close sidebar if clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (e) => {
      // Only active on mobile screens
      if (window.innerWidth <= 768 && sidebarOpen) {
        // Check if click is outside the sidebar
        const sidebar = document.querySelector('.sidebar');
        const toggleButton = document.querySelector('.mobile-sidebar-toggle');
        
        if (sidebar && !sidebar.contains(e.target) && 
            toggleButton && !toggleButton.contains(e.target)) {
          setSidebarOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarOpen, setSidebarOpen]);

  return (
    <>
      {/* Mobile sidebar toggle button */}
      <button 
        className="mobile-sidebar-toggle" 
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label={sidebarOpen ? "Close menu" : "Open menu"}
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      {/* Overlay to close sidebar on mobile */}
      <div 
        className={`mobile-close-overlay ${sidebarOpen ? 'visible' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />
    </>
  );
};

export default MobileSidebarControl;